import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { enrichCompanyRpc } from '../../../../../__generated__/chirp/com/hubspot/enrichment/applications/rpc/CustomEnrichmentService';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export function runSmartProperties(context) {
  return rpcClient.call(enrichCompanyRpc, {
    request: {
      objectId: Number(context.objectId),
      propertyNames: context.selectedProperties,
      triggerType: 'MANUAL_APPLY'
    }
  });
}